import moment from "moment";
import {
  ADD_NEW_QUOTE,
  AddNewQuoteAction,
  CREATE_NEW_FOLDER_FOR_AD,
  CreateNewFolderForAdOnDAM,
  DELETE_QUOTE_ROW,
  DELETE_UPLOADED_FILE,
  DELETE_UPLOADED_FILE_REDUCER,
  DeleteQuoteRowAction,
  DeleteUploadedFile,
  DeleteUploadedFileReducer,
  FETCH_ALL_RAISE_AD_REQUEST,
  FetchAllRaiseAdRequestAction,
  GET_AGENCY_QUOTES_DATA,
  GET_ALL_RAISE_REQUEST,
  GET_CITIES,
  GET_FILES_BY_STAGE,
  GET_QUOTATION_DATA,
  GetAgencyQuotesFormDataAction,
  GetAllRaisedRequestAction,
  GetCitiesByStateAction,
  GetFilesByStageAction,
  GetQuotationDataAction,
  PATCH_AGENCY_QUOTES,
  PatchAgencyQuotesAction,
  POST_QUOTATION_DATA,
  PostQuotationDataAction,
  RaiseAdRequestState,
  RESET_QUOTATION_DATA,
  ResetQuoationApprovalFormData,
  SAVE_QUOTE_FORM_DATA,
  SaveQuoteFormDataAction,
  SET_AGENCY_QUOTES_DATA,
  SET_AGENCY_QUOTES_ROW_DATA,
  SET_CITIES,
  SET_EMAIL_DATA,
  SET_NEW_QUOTE_ROW,
  SET_QUOTATION_DATA,
  SET_REQUEST_ID,
  SET_UPLOADED_FILE,
  SET_UPLOADED_FILE_FOR_AD_AGENCY,
  SET_USER_WORKSPACE_ROLE,
  SetAgencyQuotesFormDataAction,
  SetAgencyQuotesRowData,
  SetCitiesByStateAction,
  SetEmailDataAction,
  SetNewQuoteRow,
  SetQuotationDataAction,
  SetRequestId,
  SetUploadedFile,
  SetUploadedFileForAdAgency,
  SetUserWorkspaceRoleAction,
  START_REQUEST_LOADING,
  StartRequestLoadingAction,
  STOP_REQUEST_LOADING,
  StopRequestLoadingAction,
  UPADTE_AGENCY_QUOTES,
  UPDATE_LAST_STEP_KEY,
  UpdatehAgencyQuotesAction,
  UpdateLastStepKey,
  UPLOAD_FILE_LOADER_ACTION,
  UploadingFileLoaderAction,
} from "../types/raiseAdRequest";
import { StepKeysName } from "../../Pages/RaiseNoticeAdRequest/utils";

const initialState: RaiseAdRequestState = {
  userRole: "",
  loading: true,
  currentStepKey: StepKeysName.QuotationAndApproval,
  requestId: "",
  selectedProductId: "",
  lastStepName: "Request Creation",
  isFileUploading: false,
  states: [],
  cities: [],
  allRequests: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  quoationApprovalFormData: {
    id: 0,
    req_id: "",
    branch_code: "",
    city: "",
    otherCity: "",
    otherRequestType: "",
    gl_code: "",
    cost_code: "",
    created_at: "",
    final_release_date: null,
    creative_size: "5 x 4 cm",
    length: 0,
    metadata: {
      branch_new_address: "",
      branch_old_address: "",
      branch_address: "",
    },
    request_name: "",
    requested_by_name: "",
    request_type: "Branch Relocation",
    specific_requirements: "",
    stage: "",
    state: "",
    trashed_at: null,
    width: 0,
    workspace_id: null,
    emailContent: {
      to: "",
      cc: "",
      subject: "",
      fixedBody: "",
      greetings: "Dear Agency Team,",
      message: "",
      footerMessage: `<p style="margin:0">Please share the quote at the earliest.</p>
<p style="margin:0">Regards,</p>
<p style="margin:0">Marketing Media Team</p>`,
    },
  },
  quoteDetailsFormData: {
    data: [],
    folder_created: false,
    quote_pricing: [
      {
        key: "total_net_cost",
        insertions: "Total net cost",
        net_cost: "",
        isSummary: true,
      },
      { key: "gst", insertions: "GST", net_cost: "", isSummary: true },
      {
        key: "net_payable",
        insertions: "Net Payable",
        net_cost: "",
        isSummary: true,
      },
    ],
    stage: "",
    status: null,
    folder_url: "",
    emailContent: {
      to: "",
      cc: "",
      subject: "",
      fixedBody: "",
      greetings: "Dear Team,",
      message: "",
      footerMessage: `
      <p style="margin:0">Process for PO-</p>
      <p style="margin:0">
  1. Approval on the quote from anybody from 
  <span style="background-color: yellow;">D4 and above</span>
</p>
      <p style="margin:0">2. Cost center code with approval on the same for usage</p>
      <p style="margin:0">3. Basis above MMT raise a CAF and PO takes 3-4 days TAT</p>
      <p style="margin:0">4. Basis MMT get the PO and the final creative I'll send it for publication</p>
      <p style="margin:0px">5. Please review and share your approval at the earliest</p>
<p style="margin:0">Regards,</p>
<p style="margin:0">Marketing Media Team</p>`,
    },
  },
  finalMarketEmailContent: {
    to: "",
    cc: "",
    subject: "",
    fixedBody: "",
    greetings: "Dear Agency,",
    message: "",
    footerMessage: `
<p style="margin:0">Regards,</p>
<p style="margin:0">Marketing Media Team</p>`,
  },
  adReleaseFile: [],
  finalMarketFile: [],
  estimatesProof: [],
  softCopyProof: [],
  reviewEmailContent: {
    to: "",
    cc: "",
    subject: "",
    fixedBody: "",
    greetings: "Dear Team,",
    message: "",
    footerMessage: `<p style="margin:0">We are now closing this ticket !</p>
<p style="margin:0">Regards,</p>
<p style="margin:0">Marketing Media Team</p>`,
  },
};

export const raiseAdRequestReducer = (
  state: RaiseAdRequestState = initialState,
  action:
    | FetchAllRaiseAdRequestAction
    | GetAllRaisedRequestAction
    | SetQuotationDataAction
    | UpdateLastStepKey
    | SetCitiesByStateAction
    | SetAgencyQuotesFormDataAction
    | SetAgencyQuotesRowData
    | SetNewQuoteRow
    | DeleteQuoteRowAction
    | UpdatehAgencyQuotesAction
    | SaveQuoteFormDataAction
    | SetUploadedFileForAdAgency
    | DeleteUploadedFileReducer
    | SetEmailDataAction
    | SetRequestId
    | SetUserWorkspaceRoleAction
    | GetQuotationDataAction
    | GetCitiesByStateAction
    | PostQuotationDataAction
    | GetAgencyQuotesFormDataAction
    | AddNewQuoteAction
    | StopRequestLoadingAction
    | PatchAgencyQuotesAction
    | CreateNewFolderForAdOnDAM
    | GetFilesByStageAction
    | StartRequestLoadingAction
    | UploadingFileLoaderAction
    | DeleteUploadedFile
    | SetUploadedFile
    | ResetQuoationApprovalFormData
) => {
  switch (action.type) {
    case FETCH_ALL_RAISE_AD_REQUEST:
    case GET_QUOTATION_DATA:
    case POST_QUOTATION_DATA:
    case GET_CITIES:
    case GET_AGENCY_QUOTES_DATA:
    case ADD_NEW_QUOTE:
    case PATCH_AGENCY_QUOTES:
    case CREATE_NEW_FOLDER_FOR_AD:
    case GET_FILES_BY_STAGE:
    case START_REQUEST_LOADING:
    case DELETE_UPLOADED_FILE:
      return {
        ...state,
        loading: true,
      };
    case STOP_REQUEST_LOADING: {
      return { ...state, loading: false };
    }
    case SET_USER_WORKSPACE_ROLE: {
      return { ...state, userRole: action.payload };
    }
    case GET_ALL_RAISE_REQUEST: {
      const { data, search, page } = action.payload;

      return {
        ...state,
        loading: false,
        allRequests: {
          ...data,
          count: !!search && !data?.results?.length ? 1 : data.count,
          results:
            page === 1
              ? [...data.results]
              : [...state.allRequests.results, ...data.results],
        },
      };
    }
    case SET_REQUEST_ID: {
      const { selectedProductId, requestId } = action.payload;
      return { ...state, selectedProductId, requestId };
    }
    case SET_QUOTATION_DATA: {
      const { quotationData, states } = action.payload;
      return {
        ...state,
        loading: false,
        states,
        lastStepName: !!quotationData.stage
          ? quotationData.stage
          : "Quotation & Approval",
        quoationApprovalFormData: {
          ...quotationData,
          request_type: quotationData.request_type
            ? quotationData.request_type
            : "Branch Relocation",
          creative_size: !!quotationData.creative_size
            ? quotationData.creative_size
            : "5 x 4 cm",
          final_release_date: !!quotationData.final_release_date
            ? moment(quotationData.final_release_date)
            : null,
          metadata: {
            branch_new_address: !!quotationData.metadata.branch_new_address
              ? quotationData.metadata.branch_new_address
              : "",
            branch_old_address: !!quotationData.metadata.branch_old_address
              ? quotationData.metadata.branch_old_address
              : "",
            branch_address: !!quotationData.metadata.branch_address
              ? quotationData.metadata.branch_address
              : "",
          },
          emailContent: {
            ...state.quoationApprovalFormData.emailContent,
            ...quotationData.emailContent,
            subject: `Request Quote | ${quotationData.branch_code} | REQ-${quotationData?.id} |  ${quotationData.request_type} | Notice Ad | ${quotationData.city} | ${quotationData.state}`,
            fixedBody: `<p style="margin:0">Dear Agency Team,</p>
<p style="margin:0">We need a quote for a Notice Ad placement for: Type: ${quotationData.request_type
              }  **Branch Code**: ${quotationData.branch_code}  **City**: ${quotationData.city
              }</p>
<p style="margin:0">You can view more details about this request at - ${window.location.origin
              }#/cocreate/workflow/raise-notice-ad/${state.selectedProductId
              }/request-creation/${state.requestId}
<p style="margin:0">${quotationData.specific_requirements
                ? "There might be certain specific requirements mentioned below - "
                : ""
              } </p>
<p style="margin:0">${quotationData.specific_requirements
                ? quotationData.specific_requirements
                : ""
              }</p>
`,
            footerMessage: `<p style="margin:0">Please share the quote at the earliest.</p>
<p style="margin:0">Regards,</p>
<p style="margin:0">Marketing Media Team</p>`,
          },
        },
      };
    }

    case SAVE_QUOTE_FORM_DATA: {
      let newQuotationFormData = {
        ...state.quoationApprovalFormData,
        ...action.payload,
        metadata: {
          ...state.quoationApprovalFormData?.metadata,
          ...action.payload.metadata,
        },
      };

      if (newQuotationFormData.state !== state.quoationApprovalFormData.state) {
        newQuotationFormData.city = "";
      }

      return {
        ...state,
        quoationApprovalFormData: {
          ...newQuotationFormData,
          emailContent: {
            ...state.quoationApprovalFormData.emailContent,
            ...action.payload,
            subject: `Request Quote | ${newQuotationFormData.branch_code
              } | REQ-${newQuotationFormData?.id} | ${!!newQuotationFormData.otherRequestType &&
                newQuotationFormData.request_type === "Other"
                ? newQuotationFormData.otherRequestType
                : newQuotationFormData.request_type
              } | Notice Ad | ${newQuotationFormData.city} | ${newQuotationFormData.state
              }`,
            fixedBody: `<p style="margin:0">Dear Agency Team,</p>
<p style="margin:0">We need a quote for a Notice Ad placement for: Type: ${newQuotationFormData.request_type
              } **Branch Code**: ${newQuotationFormData.branch_code}  **City**: ${newQuotationFormData.city
              }</p>
<p style="margin:0">You can view more details about this request at - ${window.location.origin
              }#/cocreate/workflow/raise-notice-ad/${state.selectedProductId
              }/request-creation/${state.requestId}
<p style="margin:0">${newQuotationFormData.specific_requirements
                ? "There might be certain specific requirements mentioned below - "
                : ""
              } </p>
<p style="margin:0">${newQuotationFormData.specific_requirements
                ? newQuotationFormData.specific_requirements
                : ""
              }</p>
`,
            footerMessage: `<p style="margin:0">Please share the quote at the earliest.</p>
<p style="margin:0">Regards,</p>
<p style="margin:0">Marketing Media Team</p>`,
          },
        },
      };
    }
    case UPDATE_LAST_STEP_KEY: {
      const { payload } = action;

      return {
        ...state,
        loading: false,
        lastStepName: payload,
      };
    }
    case SET_CITIES: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        cities: payload,
      };
    }
    case SET_AGENCY_QUOTES_DATA: {
      const {
        data,
        folder_created,
        quote_pricing,
        stage,
        status,
        raise_req_data,
      } = action.payload;

      return {
        ...state,
        loading: false,
        lastStepName: stage,
        quoationApprovalFormData: {
          ...raise_req_data,
          final_release_date: !!raise_req_data.final_release_date
            ? moment(raise_req_data.final_release_date)
            : null,
          folder_public_url: raise_req_data?.folder_public_url
        },
        quoteDetailsFormData: {
          ...state.quoteDetailsFormData,
          data,
          folder_created,
          folder_url: !!raise_req_data?.folder_url
            ? raise_req_data?.folder_url
            : "",
          quote_pricing: [
            {
              key: "total_net_cost",
              insertions: "Total net cost",
              net_cost: isNaN(Number(quote_pricing[0]?.total_net_cost))
                ? ""
                : Number(quote_pricing[0]?.total_net_cost),
              isSummary: true,
            },
            {
              key: "gst",
              insertions: "GST(%)",
              net_cost: quote_pricing[0]?.gst,
              isSummary: true,
            },
            {
              key: "net_payable",
              insertions: "Net Payable",
              net_cost: isNaN(Number(quote_pricing[0]?.net_payable))
                ? ""
                : Number(quote_pricing[0]?.net_payable),
              isSummary: true,
            },
          ],
          status,
        },
      };
    }
    case SET_AGENCY_QUOTES_ROW_DATA: {
      const { identifier, field, value } = action.payload;
      return {
        ...state,
        quoteDetailsFormData: {
          ...state.quoteDetailsFormData,
          data: state.quoteDetailsFormData.data.map((row) =>
            row.id === identifier ? { ...row, [field]: value } : row
          ),
          quote_pricing: state.quoteDetailsFormData.quote_pricing.map((row) =>
            row.key === identifier ? { ...row, [field]: value } : row
          ),
        },
      };
    }
    case SET_NEW_QUOTE_ROW: {
      const newRowData = action.payload;
      return {
        ...state,
        loading: false,
        lastStepName: "Agency Quote Details",
        quoteDetailsFormData: {
          ...state.quoteDetailsFormData,
          data: [...state.quoteDetailsFormData.data, newRowData],
        },
      };
    }
    case DELETE_QUOTE_ROW: {
      const rowId = action.payload;
      const updatedRowData = state.quoteDetailsFormData.data.filter(
        (row) => row.id !== rowId
      );
      return {
        ...state,
        loading: true,
        lastStepName: "Agency Quote Details",
        quoteDetailsFormData: {
          ...state.quoteDetailsFormData,
          data: updatedRowData,
        },
      };
    }
    case UPADTE_AGENCY_QUOTES: {
      const { quotes_data: data, status, stage } = action.payload;
      return {
        ...state,
        loading: false,
        lastStepName: stage,
        quoteDetailsFormData: {
          ...state.quoteDetailsFormData,
          data,
          status,
        },
      };
    }
    case SET_UPLOADED_FILE_FOR_AD_AGENCY: {
      const { data, stage } = action.payload;
      let estimatesProof = state.estimatesProof || [];
      let softCopyProof = state.softCopyProof || [];

      if (stage === "Upload Proof" && Array.isArray(data)) {
        estimatesProof = data.filter((file) =>
          file.original_filename?.startsWith("Estimates_Proof")
        );

        softCopyProof = data.filter((file) =>
          file.original_filename?.startsWith("Soft_Copy_Proof")
        );
      }
      return {
        ...state,
        loading: false,
        adReleaseFile: stage === "Ad Release" ? data : state.adReleaseFile,
        finalMarketFile:
          stage === "Final Market go Live" ? data : state.finalMarketFile,
        estimatesProof,
        softCopyProof,
      };
    }
    case DELETE_UPLOADED_FILE_REDUCER: {
      const { id, stage } = action.payload;
      let estimatesProof = state.estimatesProof || [];
      let softCopyProof = state.softCopyProof || [];

      if (stage === "Upload Proof") {
        estimatesProof = state.estimatesProof.filter((file) => file.id !== id);

        softCopyProof = state.softCopyProof.filter((file) => file.id !== id);
      }
      return {
        ...state,
        loading: false,
        lastStepName: stage,
        adReleaseFile: stage === "Ad Release" ? state.adReleaseFile?.filter((file) => file?.id !== id) : state.adReleaseFile,
        finalMarketFile:
          stage === "Final Market go Live" ? [] : state.finalMarketFile,
        estimatesProof,
        softCopyProof,
      };
    }
    case SET_EMAIL_DATA: {
      const { data, stage } = action.payload;
      if (stage === 1) {
        return {
          ...state,
          quoationApprovalFormData: {
            ...state.quoationApprovalFormData,
            emailContent: {
              ...state.quoationApprovalFormData?.emailContent,
              subject: `Request Quote | ${state.quoationApprovalFormData.branch_code} | REQ-${state.quoationApprovalFormData?.id} |  ${state.quoationApprovalFormData.request_type} | Notice Ad | ${state.quoationApprovalFormData.city} | ${state.quoationApprovalFormData.state}`,
              fixedBody: `<p style="margin:0">Dear Agency Team,</p>
<p style="margin:0">We need a quote for a Notice Ad placement for: Type: ${state.quoationApprovalFormData.request_type
                } **Branch Code**: ${state.quoationApprovalFormData.branch_code
                } **City**: ${state.quoationApprovalFormData.city}</p>
<p style="margin:0">You can view more details about this request at - ${window.location.origin
                }#/cocreate/workflow/raise-notice-ad/${state.selectedProductId
                }/request-creation/${state.requestId}
`,
              footerMessage: `<p style="margin:0">Please share the quote at the earliest.</p>
<p style="margin:0">Regards,</p>
<p style="margin:0">Marketing Media Team</p>`,
              to: !!data?.to_email_ids?.length
                ? data.to_email_ids.join(",")
                : "mukul.mandal@dentsu.com,Shilvi.Shah@dentsu.com,Vishal.Gohil@dentsu.com,Tanay.Haryan@iprospect.com",
              cc: !!data?.cc_email_ids?.length
                ? data.cc_email_ids.join(",")
                : "nikhil.bhosale@hdfc.bank.in,abhishek.mathur4@hdfc.bank.in,mita.vora@dentsu.com",
              message: !!data?.email_content?.message
                ? data.email_content.message
                : "", // merge the new email data here
            },
          },
        };
      }
      if (stage === 3) {
        return {
          ...state,
          quoteDetailsFormData: {
            ...state.quoteDetailsFormData,
            emailContent: {
              ...state.quoteDetailsFormData?.emailContent,
              subject: `Quotation Approval | ${state.quoationApprovalFormData.branch_code} | REQ-${state.quoationApprovalFormData?.id} |  ${state.quoationApprovalFormData.request_type} | Notice Ad | ${state.quoationApprovalFormData.city} | ${state.quoationApprovalFormData.state}`,
              fixedBody: `<p style="margin:0">Dear Team,</p>
<p style="margin:0">Below is the quote for your review. Kindly help with the business approval. Type: ${state.quoationApprovalFormData.request_type} **Branch Code**: ${state.quoationApprovalFormData.branch_code} **City**: ${state.quoationApprovalFormData.city}</p>
<p style="margin:0">Please click below to access the quote - ${window.location.origin}#/cocreate/workflow/raise-notice-ad/${state.selectedProductId}/request-creation/${state.requestId}
`,
              to: !!data?.to_email_ids?.length
                ? data.to_email_ids.join(",")
                : "",
              cc: !!data?.cc_email_ids?.length
                ? data.cc_email_ids.join(",")
                : "",
              message: !!data?.email_content?.message
                ? data.email_content.message
                : "", // merge the new email data here
            },
          },
        };
      }

      if (stage === 5) {
        return {
          ...state,
          finalMarketEmailContent: {
            ...state.finalMarketEmailContent,
            subject: `PO approved | ${state.quoationApprovalFormData.branch_code} | REQ-${state.quoationApprovalFormData?.id} |  ${state.quoationApprovalFormData.request_type} | Notice Ad | ${state.quoationApprovalFormData.city} | ${state.quoationApprovalFormData.state}`,
            fixedBody: `<p style="margin:0"> Please find attached PO and Approved Creatives. Please align the Ad to be released at the earliest.</p>`,
            to: !!data?.to_email_ids?.length ? data.to_email_ids.join(",") : "",
            cc: !!data?.cc_email_ids?.length ? data.cc_email_ids.join(",") : "",
            message: !!data?.email_content?.message
              ? data.email_content.message
              : "",
          },
        };
      }

      if (stage === 7) {
        return {
          ...state,
          reviewEmailContent: {
            ...state.reviewEmailContent,
            to: !!data?.to_email_ids?.length ? data.to_email_ids.join(",") : "",
            cc: !!data?.cc_email_ids?.length ? data.cc_email_ids.join(",") : "",
            message: !!data?.email_content?.message
              ? data.email_content.message
              : "",
          },
        };
      }

      return { ...state };
    }
    case UPLOAD_FILE_LOADER_ACTION: {
      return { ...state, isFileUploading: action.payload };
    }

    case RESET_QUOTATION_DATA:{
      return {...state,
        quoationApprovalFormData: initialState.quoationApprovalFormData,
        quoteDetailsFormData: initialState.quoteDetailsFormData
      }
    }

    default: {
      return state;
    }
  }
};
